import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from '../../context/context';
import { Table, Button, Pagination, Select, Group, Grid, Divider, ActionIcon, Box } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faCircleInfo, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';

const DataTableInterlineales = ({ data, setId, conteocr, conteoh, conteov, conteocs }) => {

    const appcontext = useContext(AppContext);
    const columns = React.useMemo(() => {
        if (data.length === 0) return [];
        var headers = ["FECHA VUELO", "EJECUTIVO", "# GUIA", "QTY", "WEIGHT", "CM3", "TONS", "DESC", "SCH", "DIMS", "FORWARDER", "OPT"]
        //carriers
        headers.push("CARRIER ");
        for (let i = 2; i < conteocr; i++)
            headers.push("CARRIER " + i);

        headers.push("ORIGIN");
        //hubs
        headers.push("HUBS DEP");
        for (let i = 1; i < conteoh; i++)
            headers.push("HUBS " + i);

        headers.push("DEST");
        ///vuelos
        headers.push("VUELO ");
        for (let i = 2; i < conteov; i++)
            headers.push("VUELO " + i);

        //conexions
        headers.push("CNX DETAILS");
        for (let i = 2; i < conteocs; i++)
            headers.push("CNX DETAILS " + i);

        headers.push("REMARKS");
        headers.push("TIPO");
        headers.push("VUELO MEX");
        headers.push("FECHA CONEXION");
        headers.push("LLEGADA PTO CNX");
        headers.push("DIA CONEXION");
        headers.push("TIEMPO CONEXION");
        headers.push("OBSERVACIONES");
        return headers;
    }, [data]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [filter, setFilter] = useState('');


    /*const filteredData = data.filter(item =>
        Object.values(item).some(value =>
            value != null && value.toString().trim() !== '' && value.toString().toLowerCase().includes(filter.toLowerCase())
        )
    );*/
    // State for filtered data
    const [filteredData, setFilteredData] = useState(data);

    // State for multiple column filters: [{ column: '', value: '' }, ...]
    const [filters, setFilters] = useState([]);

    useEffect(() => {
        setFilteredData(data);
        setFilters([]);
        setPage(1);
    }, [data]);

    // Apply the list of filters to the data
    const applyFilters = (filterList) => {
        const newFilteredData = data.filter((row) => {
            return filterList.every((f) => {
                if (!f.column || f.value === '') return true;
                const filterValue = f.value.toLowerCase();
                const cellValue = row[f.column] ? row[f.column].toString().toLowerCase() : '';
                return cellValue.includes(filterValue);
            });
        });
        setFilteredData(newFilteredData);
        setPage(1);
    };

    const addFilter = () => {
        setFilters([...filters, { column: '', value: '' }]);
    };

    const removeFilter = (index) => {
        const updated = filters.filter((_, i) => i !== index);
        setFilters(updated);
        applyFilters(updated);
    };

    const handleFilterColumnChange = (index, column) => {
        const updated = filters.map((f, i) => (i === index ? { ...f, column: column || '' } : f));
        setFilters(updated);
        applyFilters(updated);
    };

    const handleFilterValueChange = (index, value) => {
        const updated = filters.map((f, i) => (i === index ? { ...f, value } : f));
        setFilters(updated);
        applyFilters(updated);
    };


    // Paleta de colores por valor de CNX DETAILS
    const CNX_COLOR_MAP = {
        'Pending Connection': '#000000', // negro
        'At Connection':      '#2f9e44', // verde
        'In Transit':         '#7030a0', // morado
        'At Destination':     '#0070c0', // azul
        'Cancelled':          '#e03131', // rojo
    };

    const CNX_PRIORITY = ['Cancelled', 'In Transit', 'Pending Connection', 'At Destination', 'At Connection'];

    const getRowColor = (row) => {
        const statuses = Object.keys(row)
            .filter((key) => key.includes('CNX DETAIL'))
            .map((key) => (row[key] != null ? row[key].toString().trim() : ''))
            .filter((val) => val !== '');

        if (statuses.length === 0) return undefined;

        if (statuses.some(s => s.toLowerCase().includes('cancel'))) return CNX_COLOR_MAP['Cancelled'];
        if (statuses.some(s => s.toLowerCase().includes('in transit'))) return CNX_COLOR_MAP['In Transit'];
        if (statuses.some(s => s.toLowerCase().includes('pending connection'))) return CNX_COLOR_MAP['Pending Connection'];
        if (statuses.some(s => s.toLowerCase().includes('at destination'))) return CNX_COLOR_MAP['At Destination'];
        if (statuses.some(s => s.toLowerCase().includes('at connection'))) return CNX_COLOR_MAP['At Connection'];
        return undefined;
    };

    const totalRecords = filteredData.length;
    const totalPages = Math.ceil(filteredData.length / pageSize);
    const startIndex = (page - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalRecords);
    const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);


    const handleEdit = (id) => {
        setId(id);
        appcontext.setStatusFNR(true);
    }

    const handleInfo = (id) => {
        setId(id);
        appcontext.setStatusFNI(true);
    }
    return (
        <>
            {/* Render filters for each column dynamically  <Group justify="space-between">
                <Select
                    label="Registros por pagina"
                    value={pageSize.toString()}
                    onChange={(value) => setPageSize(parseInt(value, 10))}
                    data={[5, 10, 20, 30, 50].map((size) => ({ value: size.toString(), label: size.toString() }))}
                />
                <TextInput
                    label="Buscar"
                    placeholder="Buscar..."
                    value={filter}
                    onChange={(event) => { setFilter(event.currentTarget.value); setPage(1) }}
                />
            </Group>
            */}
            <Group justify="space-between" align="flex-end">
                <Select
                    label="Registros por pagina"
                    value={pageSize.toString()}
                    onChange={(value) => setPageSize(parseInt(value, 10))}
                    data={[5, 10, 20, 30, 50].map((size) => ({ value: size.toString(), label: size.toString() }))}
                />
                <Button
                    variant="outline"
                    color="#035CF7"
                    leftSection={<FontAwesomeIcon icon={faPlus} />}
                    onClick={addFilter}
                >
                    Agregar filtro
                </Button>
            </Group>

            {filters.length > 0 && (
                <Box mt="sm">
                    {filters.map((f, index) => (
                        <Group key={index} align="flex-end" mb="xs">
                            <Select
                                label="Columna"
                                placeholder="Selecciona una columna"
                                searchable
                                data={columns}
                                value={f.column || null}
                                onChange={(value) => handleFilterColumnChange(index, value)}
                                style={{ minWidth: 220 }}
                            />
                            <Select
                                label="Valor"
                                placeholder="Selecciona un valor..."
                                searchable
                                clearable
                                nothingFoundMessage="Sin opciones..."
                                data={
                                    f.column
                                        ? [...new Set(
                                            data
                                                .map(row => row[f.column])
                                                .filter(v => v != null && v.toString().trim() !== '')
                                                .map(v => v.toString())
                                          )].sort()
                                        : []
                                }
                                value={f.value || null}
                                onChange={(value) => handleFilterValueChange(index, value || '')}
                                disabled={!f.column}
                                style={{ minWidth: 220 }}
                            />
                            <ActionIcon
                                variant="outline"
                                color="red"
                                size="lg"
                                onClick={() => removeFilter(index)}
                                title="Eliminar filtro"
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </ActionIcon>
                        </Group>
                    ))}
                </Box>
            )}
            <Grid.Col span={12}>
                <Divider size="sm" />
            </Grid.Col>

            <Table.ScrollContainer minWidth={500} type="native">
                <Table id="example" striped highlightOnHover withTableBorder>
                    <Table.Thead >
                        <Table.Tr>
                            <Table.Th style={{ backgroundColor: '#035cf7', color: '#F2F2F0' }}>
                                ACCIONES
                            </Table.Th>
                            {columns.map(column => (
                                <Table.Th key={column} style={{ backgroundColor: '#035cf7', color: '#F2F2F0', whiteSpace: 'nowrap', minWidth: '200px' }}>
                                    {column === 'FECHA VUELO'?"FECHA CREACION":column}
                                </Table.Th>
                            ))}
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {
                            paginatedData.map((row, rowIndex) => {
                                const rowColor = getRowColor(row);
                                return (
                                <Table.Tr key={rowIndex} style={rowColor ? { color: rowColor } : undefined}>
                                    <Table.Td>
                                        <Button.Group>
                                            <Button variant="outline" color='#FCC732' onClick={() => { handleEdit(row["id"]) }}><FontAwesomeIcon icon={faPen} /></Button>
                                            <Button variant="outline" color='#035CF7' onClick={() => { handleInfo(row["id"]) }}><FontAwesomeIcon icon={faCircleInfo} /></Button>
                                        </Button.Group>
                                    </Table.Td>
                                    {columns.map(column => (
                                        <Table.Td key={column} style={{ whiteSpace: 'nowrap', color: rowColor || undefined }}>
                                            {row[column]}
                                        </Table.Td>
                                    ))}
                                </Table.Tr>
                                );
                            })
                        }
                    </Table.Tbody>
                </Table>
            </Table.ScrollContainer>
            <Grid.Col span={12}>
                <Divider size="sm" />
            </Grid.Col>
            <Group justify="space-between">
                <Pagination
                    total={totalPages}
                    page={page}
                    onChange={setPage}
                    styles={{ control: { margin: '0 5px' } }}
                />
                <div style={{ marginTop: '10px' }}>
                    Showing {startIndex + 1} to {(endIndex + 1) > totalRecords ? totalRecords : endIndex + 1} of {totalRecords} entries
                </div>
            </Group>

        </>
    );
};

export default DataTableInterlineales;